import { Tab, Row, Col, Nav } from 'react-bootstrap';
import Logo from './../../images/ReactJSLogoImg.png';

const tabsData = [
	{ eventKey: 'ReactJS-Introduction', event: 'React Introduction' },
	{ eventKey: 'React-Installation', event: 'React Installation' },
	{ eventKey: 'React-Features', event: 'React Features' },
	{ eventKey: 'React-JSX', event: 'React JSX' },
	{ eventKey: 'React-Components', event: 'React Components' },
	{ eventKey: 'React-StatesAndPropes', event: 'React State and Props' },
	{ eventKey: 'React-ComponentLifeCycle', event: 'Component Life Cycle' },
	{ eventKey: 'React-Forms', event: 'React Forms' },
	{ eventKey: 'React-Styling', event: 'React Styling' },
	{ eventKey: 'React-Events', event: 'React Events' },
	{ eventKey: 'React-Routing', event: 'React Routing' }];

const ReactJS = () => {
	return (
		<div className="container-fluid">
			<div className="row paddingBottom20">
				<div className="col-lg-2"></div>
				<div className="col-lg-8">
					<div className="col-lg-12" >
						<div className="row" >
							<div className="col-lg-12 header">
								<h3><img src={Logo} className="paddingRight20" alt="Spring Logo not found" style={{ 'paddingRight': '10px', 'height': '50px', 'width': '50px' }} />
									ReactJS
								</h3>
								<hr />
							</div>
							<div className="col-lg-12 paddingBottom10">

								ReactJS is a declarative, efficient, and flexible JavaScript library for building reusable UI components. 
								It is an open-source, component-based front end library which is responsible only for the view layer of the 
								application. It was initially developed and maintained by Facebook and later used in its products 
								like WhatsApp and Instagram.

							</div>
							<div className="col-lg-12 paddingTop20">

								<Tab.Container id="left-tabs-example" defaultActiveKey={tabsData[0].eventKey}>
									<Row>
										<Col sm={3}>
											<Nav variant="pills" className="flex-column menuItems">
												{tabsData.map((tabData, index) => {
													const hrefData= '#'+tabData.eventKey;
													return <Nav.Item key={tabData.eventKey}>
														<Nav.Link href={hrefData} eventKey={tabData.eventKey}>{index + 1}.) {tabData.event}</Nav.Link>
													</Nav.Item>
													}
												)}
											</Nav>
										</Col>
										<Col sm={9}>
											<Tab.Content>
												<ReactIntroduction />
												<ReactInstallation />
												<ReactFeatures />
												<ReactJSX />
												<ReactComponents />
												<ReactStatesAndPropes />
												<ReactComponentLifeCycle />
												<ReactForms/>
												<ReactStyling />
												<ReactEvents />
												<ReactRouting />
											</Tab.Content>
										</Col>
									</Row>
								</Tab.Container>
							</div>
							<div className="col-lg-12 paddingTop20">
								<span className="textColorPink">
									<b>Disclaimer: </b>
									Content of this page has been referred from <a href="https://react.dev/" target="_blank" rel="noreferrer">ReactJS</a>.
								</span> 
							</div>
						</div>
					</div>
				</div>
				<div className="col-lg-2"></div>
			</div>
		</div>

	);
}

export default ReactJS;

const ReactIntroduction = () => {
	return (
		<Tab.Pane id="ReactJS-Introduction" eventKey="ReactJS-Introduction">
			<div id="ReactJS-Introduction">
				<p>
					<h5>React Introduction</h5>
					Today, most of the websites are built using <b>MVC</b> (model view controller) architecture. 
					In MVC architecture, React is the <b>'V'</b> which stands for view, whereas the architecture is 
					provided by the Redux or Flux.
					<br/>
					A ReactJS application is made up of multiple components, each component responsible for outputting a small, 
					reusable piece of HTML code. The components are the heart of all React applications.
					<br/> 
					These Components can be nested with other components to allow complex applications to be built of simple 
					building blocks. ReactJS uses virtual <b>DOM</b> based mechanism to fill data in HTML <b>DOM</b>. 
					<br/>
					The virtual <b>DOM</b> works fast as it only changes individual <b>DOM</b> elements instead of reloading complete <b>DOM</b> every time
					<br/><br/>
					<h6>Why we use ReactJS?</h6>
					
					The main objective of ReactJS is to develop User Interfaces (UI) that improves the speed of the apps. 
					It uses virtual <b>DOM</b> (JavaScript object), which improves the performance of the app. 
					The JavaScript virtual <b>DOM</b> is faster than the regular <b>DOM</b>. We can use ReactJS on the client and server-side 
					as well as with other frameworks. It uses component and data patterns that improve readability and 
					helps to maintain larger apps.

				</p>
			</div>
		</Tab.Pane>
	)
};


const ReactInstallation = () => {
	return (
		<Tab.Pane id="React-Installation" eventKey="React-Installation">
			<div id="React-Installation">
				<p>
					<h5>React Installation</h5>
					In this section, we will learn how to set up an environment for the successful development of ReactJS application.
					<br/>
					<h6>Pre-requisite for ReactJS</h6> 
					<ul>
						<li>NodeJS and NPM</li>
						<li>React and React DOM</li>
						<li>Webpack</li>
						<li>Babel</li>
					</ul>
					<h6>Ways to install ReactJS</h6>
					There are two ways to set up an environment for successful ReactJS application. They are given below.
					<br/>
					<ul>
						<li>Using the npm command 
							<ul><li>npm install react react-dom --save </li></ul> 
						</li>
						<li>Using the create-react-app command 
							<ul><li> npm install -g create-react-app</li>
								<li>create-react-app my-reactapp</li>
							</ul>
						</li> 
					</ul>					
				</p>
			</div>
		</Tab.Pane>
	)
};

const ReactFeatures = () => {
	return (
		<Tab.Pane id="React-Features" eventKey="React-Features">
			<div id="React-Features">
				<p>
					<h5>React Features</h5>
					Currently, ReactJS gaining quick popularity as the best JavaScript framework among web developers. 
					It is playing an essential role in the front-end ecosystem. 
					<br/>
					The important features of ReactJS are as following.
					<ol>
						<li><b>JSX</b> - JSX stands for JavaScript XML. It is a JavaScript syntax extension. 
							Its an XML or HTML like syntax used by ReactJS. This syntax is processed into JavaScript 
							calls of React Framework. It extends the ES6 so that HTML like text can co-exist with JavaScript react code. 
							It is not necessary to use JSX, but it is recommended to use in ReactJS.</li>
						<li><b>Components</b> - ReactJS is all about components. ReactJS application is made up of multiple components, 
							and each component has its own logic and controls. These components can be reusable which help us to maintain 
							the code when working on larger scale projects.</li>
						<li><b>One-way Data Binding</b> - ReactJS is designed in such a manner that follows unidirectional data flow 
							or one-way data binding. The benefits of one-way data binding give us better control throughout the application.</li>
					 	<li><b>Virtual DOM</b> - A virtual DOM object is a representation of the original DOM object. It works like 
					 		a one-way data binding. Whenever any modifications happen in the web application, the entire UI is re-rendered 
					 		in virtual DOM representation. Then it checks the difference between the previous DOM representation and new DOM. 
					 		Once it has done, the real DOM will update only the things that have actually changed. 
					 		This makes the application faster, and there is no wastage of memory.</li>
						<li><b>Simplicity</b> - ReactJS uses JSX file which makes the application simple and to code as well as understand. 
							We know that ReactJS is a component-based approach which makes the code reusable as our need. 
							This makes it simple to use and learn.</li>
						<li><b>Performance</b> - ReactJS is known to be a great performer. This feature makes it much better than
						 	other frameworks out there today. The reason behind this is that it manages a virtual DOM. 
						 	The DOM is a cross-platform and programming API which deals with HTML, XML or XHTML. 
						 	The DOM exists entirely in memory. Due to this, when we create a component, we did not write directly to the DOM. 
						 	Instead, we are writing virtual components that will turn into the DOM leading to smoother and faster performance.</li>
					</ol>
				</p>
			</div>
		</Tab.Pane>
	)
};


const ReactJSX = () => {
	return (
		<Tab.Pane id="React-JSX" eventKey="React-JSX">
			<div id="React-JSX">
				<p>
					<h5>React JSX(<b>J</b>ava<b>S</b>cript e<b>X</b>tension)</h5>
					JSX is a syntax extension to JavaScript. We recommend using it with React to describe what the UI should look like.
					<br/>
					JSX may remind us of a template language, but it comes with the full power of JavaScript.
					<br/>
					JSX produces React <b>'elements'</b>.
					<br/><br/>
					Consider below variable declaration -
					<p className="pCode">
						const element = &lt;h1&gt;Hello, world!&lt;/h1&gt;;
					</p>
					
					This funny tag syntax is neither a string nor HTML. It is called <b>JSX</b>.
					<br/><br/>
					<h5>Why JSX?</h5>
					React embraces the fact that rendering logic is inherently coupled with other UI logic: how events are handled, 
					how the state changes over time, and how the data is prepared for display.
					<br/>
					Instead of artificially separating technologies by putting markup and logic in separate files, 
					React separates concerns with loosely coupled units called <b>'components'</b> that contain both. 
					We will come back to components in a next section, but if we’re not yet comfortable putting markup in <b>JS</b>, 
					this talk might convince us otherwise.
					<br/><br/>
					React doesn’t require using <b>JSX</b>, but most people find it helpful as a visual aid when working with UI inside 
					the JavaScript code. It also allows React to show more useful error and warning messages.
				</p>
			</div>
		</Tab.Pane>
	)
};


const ReactComponents = () => {
	return (
		<Tab.Pane id="React-Components" eventKey="React-Components">
			<div id="React-Components">
				<p>
					<h5>React Components</h5>
					Earlier, the developers write more than thousands of lines of code for developing a single page application. 
					These applications follow the traditional DOM structure, and making changes in them was a very challenging task.
					 If any mistake found, it manually searches the entire application and update accordingly. 
					 The component-based approach was introduced to overcome an issue. In this approach, the entire application is 
					 divided into a small logical group of code, which is known as components.
					<br/><br/>
					A Component is considered as the core building blocks of a React application. It makes the task of building UIs 
					much easier. Each component exists in the same space, but they work independently from one another and 
					merge all in a parent component, which will be the final UI of our application.
					<br/><br/>
					Every React component have their own structure, methods as well as APIs. They can be reusable as per our need. 
					For better understanding, consider the entire UI as a tree. Here, the root is the starting component, 
					and each of the other pieces becomes branches, which are further divided into sub-branches.
					<br/>
					<ul>
						<li><b>Functional Components </b> - 
							In React, function components are a way to write components that only contain a render method and don't 
							have their own state. They are simply JavaScript functions that may or may not receive data as parameters. 
							We can create a function that takes props(properties) as input and returns what should be rendered.
						</li>
					
						<li><b>Class Components</b> -
							Class components are more complex than functional components. It requires us to extend from React. 
							Component and create a render function which returns a React element. We can pass data from one class to 
							other class components. We can create a class by defining a class that extends Component and has a 
							render function.
						</li>
					</ul>
				</p>
			</div>
		</Tab.Pane>
	)
};


const ReactStatesAndPropes = () => {
	return (
		<Tab.Pane id="React-StatesAndPropes" eventKey="React-StatesAndPropes">
			<div id="React-StatesAndPropes">
				<p>
					<h5>React State</h5>
					
					The state is an updatable structure that is used to contain data or information about the component. 
					The state in a component can change over time. The change in state over time can happen as a response 
					to user action or system event. A component with the state is known as stateful components.
					<br/> 
					It is the heart of the react component which determines the behavior of the component and how it will render. 
					<br/>
					They are also responsible for making a component dynamic and interactive.
					<br/>
					A state must be kept as simple as possible. It can be set by using the <b>setState()</b> method and calling <b>setState()</b> 
					method triggers UI updates. A state represents the component's local state or information. It can only be accessed 
					or modified inside the component or by the component directly. To set an initial state before any 
					interaction occurs, we need to use the <b>getInitialState()</b> method.
					
					<br/><br/>
					<h5>React Props</h5>
					
					Props stand for <b>'Properties'</b>. They are read-only components. 
					<br/>
					It is an object which stores the value of attributes of a tag and work similar to the HTML attributes. 
					It gives a way to pass data from one component to other components. It is similar to function arguments. 
					<br/>
					Props are passed to the component in the same way as arguments passed in a function.
					<br/>
					Props are immutable so we cannot modify the props from inside the component. Inside the components, 
					we can add attributes called props. These attributes are available in the component as <b>this.props</b> and 
					can be used to render dynamic data in our <b>render</b> method.

				</p>
			</div>
		</Tab.Pane>
	)
};

const ReactComponentLifeCycle = () => {
	return (
		<Tab.Pane id="React-ComponentLifeCycle" eventKey="React-ComponentLifeCycle">
			<div id="React-ComponentLifeCycle">
				<p>
					<h5>Component Life Cycle</h5>
					In ReactJS, every component creation process involves various lifecycle methods. These lifecycle methods 
					are termed as component's lifecycle. These lifecycle methods are not very complicated and called at various 
					points during a component's life. 
					<br/>
					The lifecycle of the component is divided into four phases. 
					<br/>
					They are:
					<ol>
						<li><h6>Initial Phase</h6> It is the birth phase of the lifecycle of a ReactJS component. Here, the component starts its 
							journey on a way to the DOM. In this phase, a component contains the default Props and initial State. 
							These default properties are done in the constructor of a component.
						</li>
						<li><h6>Mounting Phase</h6> In this phase, the instance of a component is created and inserted into the DOM.
							<br/> 
							It consists of the following methods.
							<ul>
								<li><b>componentWillMount()</b> -
									This is invoked immediately before a component gets rendered into the DOM. 
									In the case, when we call setState() inside this method, the component will not re-render.
								</li>	
								<li><b>componentDidMount()</b> - 
									This is invoked immediately after a component gets rendered and placed on the DOM. 
									Now, we can do any DOM querying operations.
								</li>
								<li><b>render()</b> - 
									This method is defined in each and every component. It is responsible for returning a 
									single root HTML node element. If we don't want to render anything, we can return a null or false value.
								</li>
							</ul>
						</li>
						<li><h6>Updating Phase</h6> It is the next phase of the lifecycle of a react component. 
							Here, we get new Props and change State. This phase also allows to handle user interaction and provide 
							communication with the components hierarchy. The main aim of this phase is to ensure that the component is 
							displaying the latest version of itself. Unlike the Birth or Death phase, this phase repeats again and again. 
							<br/>
							This phase consists of the following methods.
							<ul>
								<li><b>componentWillRecieveProps()</b> - 
									It is invoked when a component receives new props. If we want to update the state in response to prop changes, 
									we should compare this.props and nextProps to perform state transition by using this.setState() method.
								</li>
								<li><b>shouldComponentUpdate()</b> - 
								
									It is invoked when a component decides any changes/updation to the DOM. It allows us to control 
									the component's behavior of updating itself. If this method returns true, the component will update. 
									Otherwise, the component will skip the updating.
								</li>
								<li><b>componentWillUpdate()</b> - 
									It is invoked just before the component updating occurs. Here, we can't change the component state 
									by invoking this.setState() method. It will not be called, if shouldComponentUpdate() returns false.
								</li>
								<li><b>render()</b> -
									It is invoked to examine this.props and this.state and return one of the following types: 
									React elements, Arrays and fragments, Booleans or null, String and Number. 
									If shouldComponentUpdate() returns false, the code inside render() will be invoked again to 
									ensure that the component displays itself properly.
								</li>
								<li><b>componentDidUpdate()</b> -
									It is invoked immediately after the component updating occurs. In this method, we can put any code 
									inside this which we want to execute once the updating occurs. This method is not invoked for the 
									initial render.
								</li>
							</ul>
						</li>
						<li><h6>Unmounting Phase</h6> It is the final phase of the react component lifecycle. It is called when a component 
							instance is destroyed and unmounted from the DOM. 
							<br/>
							This phase contains only one method and is given below.
							<ul>
								<li><b>componentWillUnmount()</b> - 
									This method is invoked immediately before a component is destroyed and unmounted permanently. 
									It performs any necessary cleanup related task such as invalidating timers, event listener, 
									canceling network requests, or cleaning up DOM elements. If a component instance is unmounted, 
									we cannot mount it again.
								</li>
							</ul>
						</li>
					</ol>
				</p>
			</div>
		</Tab.Pane>
	)
};

const ReactForms = () => {
	return (
		<Tab.Pane id="React-Forms" eventKey="React-Forms">
			<div id="React-Forms">
				<p>
					<h5>Ract Forms</h5>
					Forms are an integral part of any modern web application. It allows the users to interact with the 
					application as well as gather information from the users. Forms can perform many tasks that depend on 
					the nature of our business requirements and logic such as authentication of the user, adding user, searching, 
					filtering, booking, ordering, etc. A form can contain text fields, buttons, checkbox, radio button, etc.

					<ul>
						<li>
							<h5>Uncontrolled component</h5>
							The uncontrolled input is similar to the traditional HTML form inputs. 
							The <b>DOM</b> itself handles the form data. Here, the HTML elements maintain their own state that will 
							be updated when the input value changes. 
							<br/>
							To write an uncontrolled component, 
							we need to use a ref to get form values from the <b>DOM</b>. In other words, there is no need to 
							write an event handler for every state update. We can use a ref to access the input field value of 
							the form from the <b>DOM</b>.
							<br/><br/>
						</li>
						<li><h5>Controlled Component</h5> 
							In HTML, form elements typically maintain their own state and update it according to the user input. 
							In the controlled component, the input form element is handled by the component rather than the DOM. 
							Here, the mutable state is kept in the state property and will be updated only with <b>setState()</b> method.
							<br/>
							Controlled components have functions that govern the data passing into them on every onChange event, 
							rather than grabbing the data only once, e.g., when we click a submit button. 
							This data is then saved to state and updated with <b>setState()</b> method. 
							This makes component have better control over the form elements and data.
							<br/>
							A controlled component takes its current value through props and notifies the changes through 
							callbacks like an onChange event. A parent component 'controls' this changes by handling the callback 
							and managing its own state and then passing the new values as props to the controlled component. 
							<br/>
							It is also called as a <b>'dumb component'</b>.
						</li>
					</ul>

				</p>
			</div>
		</Tab.Pane>
	)
};

const ReactStyling = () => {
	return (
		<Tab.Pane id="React-Styling" eventKey="React-Styling">
			<div id="React-Styling">
				<p>
					<h5>React Styling</h5>
					CSS in React is used to style the React App or Component. The style attribute is the most used attribute 
					for styling in React applications, which adds dynamically-computed styles at render time. 
					It accepts a JavaScript object in camelCased properties rather than a CSS string. 
					There are many ways available to add styling to our React App or Component with CSS. 
					<br/>
					Here, we are going to discuss mainly four ways to style React Components, 
					which are given below -
					<ul>
						<li><b>Inline Styling</b> - The inline styles are specified with a JavaScript object in 
							camelCase version of the style name. Its value is the style?s value, which we usually take in a string.
						</li>
						<li><b>CSS Stylesheet</b> - We can write styling in a separate file for our React application, 
							and save the file with a .css extension. Now, We can import this file in our application.
						</li>
						<li><b>CSS Module</b> - CSS Module is another way of adding styles to our application. 
							It is a CSS file where all class names and animation names are scoped locally by default. 
							It is available only for the component which imports it, means any styling we add can never 
							be applied to other components without our permission, and we never need to worry about name conflicts. 
							We can create CSS Module with the .module.css extension like a myStyles.module.css name.
						</li>
						<li><b>Styled Components</b> - Styled-components is a library for React. It uses enhance CSS for 
							styling React component systems in our application, which is written with a mixture of JavaScript and CSS.
						</li>
					</ul>	
				</p>
			</div>
		</Tab.Pane>
	)
};

const ReactEvents = () => {
	return (
		<Tab.Pane id="React-Events" eventKey="React-Events">
			<div id="React-Events">
				<p>
					<h5>React Events</h5>
					An event is an action that could be triggered as a result of the user action or system generated event. 
					For example, a mouse click, loading of a web page, pressing a key, window resizes, and other interactions 
					are called events.
					<br/><br/>
					React has its own event handling system which is very similar to handling events on <b>DOM</b> elements. 
					The react event handling system is known as Synthetic Events. The synthetic event is a cross-browser wrapper 
					of the browser's native event.
					
					<br/><br/>
					Handling events with react have some syntactic differences from handling events on DOM. These are -
					<ul>
						<li>React events are named as camelCase instead of lowercase.</li>
						<li>With JSX, a function is passed as the event handler instead of a string.</li>
					</ul>
				</p>
			</div>
		</Tab.Pane>
	)
};


const ReactRouting = () => {
	return (
		<Tab.Pane id="React-Routing" eventKey="React-Routing">
			<div id="React-Routing">
				<p>
					<h5>React Routing</h5>
					Routing is a process in which a user is directed to different pages based on their action or request. 
					ReactJS Router is mainly used for developing Single Page Web Applications. 
					React Router is used to define multiple routes in the application. When a user types a specific 
					URL into the browser, and if this URL path matches any 'route' inside the router file, 
					the user will be redirected to that particular route.
					<br/>
					React Router is a standard library system built on top of the React and used to create routing in 
					the React application using React Router Package. It provides the synchronous URL on the browser with 
					data that will be displayed on the web page. It maintains the standard structure and behavior of the 
					application and mainly used for developing single page web applications.
					<br/><br/>
					<h6>React Router Installation</h6>
					React contains three different packages for routing. These are -
					<ul>
						<li><b>react-router</b> It provides the core routing components and functions for the React Router applications.</li>
						<li><b>react-router-native</b> It is used for mobile applications.</li>
						<li><b>react-router-dom</b> It is used for web applications design.</li>
					</ul>
					It is not possible to install react-router directly in our application. 
					To use react routing, first, we need to install react-router-dom modules in our application. 
					<br/>
					The below command is used to install react router dom.
					<p className="pCode">
						$npm install react-router-dom --save
					</p>
					<h6>What is Route?</h6>
					It is used to define and render component based on the specified path. 
					It will accept components and render to define what should be rendered.
					<br/><br/>
					<h6>React Router Switch</h6>
					The &lt;Switch&gt; component is used to render components only when the path will be matched. 
					Otherwise, it returns to the not found component

				</p>
			</div>
		</Tab.Pane>
	)
};
